var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppPortfolio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5049 14.4309C26.5351 14.4309 30.4946 17.7241 30.4946 23.2376C30.4946 29.676 25.1289 32.2661 20.0967 32.2661H16.6924V39.2227H9.81006V14.4309H19.5049ZM16.6924 20.3145V26.3828H19.7266C21.8359 26.3828 23.3164 25.5317 23.3164 23.3855C23.3164 21.4243 22.0581 20.3145 19.875 20.3145L16.6924 20.3145Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1631 25.2356H31.7578V20.0923H34.1631C34.2739 15.874 37.0493 13.4688 41.4155 13.4688C42.5254 13.4688 43.5986 13.5798 44.1904 13.802L44.1538 18.5752C43.7466 18.4272 43.1548 18.3533 42.6367 18.3533C41.1562 18.3533 40.7124 19.0193 40.6387 20.0923H44.1538V25.2356H40.6387V39.2226H34.1631L34.1631 25.2356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppPortfolio);
export default __webpack_public_path__ + "static/media/B_app_Portfolio.23b8089aa5057e3629b0319d7d540fab.svg";
export { ForwardRef as ReactComponent };